enum MediaEnum {
  DESKTOP = '(min-width: 1280px)',
}

// TODO: investigate SSR https://novoplex.atlassian.net/browse/DEV-213
export const useMedia = () => {
  if (typeof window === 'undefined')
    return { isDesktop: false, isMobile: true };

  const isDesktop = window.matchMedia(MediaEnum.DESKTOP).matches;
  return { isDesktop, isMobile: !isDesktop };
};
